import React, { useEffect, useState, useRef } from "react";
import AppHeader from "../../components/header";
import Dropdown from "react-bootstrap/Dropdown";
import Collapsible from "../../components/sections/CollapsibleFilter/CollapsibleFilter";
import GridView from "../../components/ItemsCardView/ItemsCardGridView";
import ListView from "../../components/ItemsCardView/ItemsCardListView";
import Pagination from "../../components/pagination/Pagination";
// import TextSection from "../../components/sections/BottomTextSetion/BottomTextSetion";
import ListIcon from "../../assets/images/icons/icon-list.svg";
// import QuickFilters from "../../components/sections/QuickFilters";
import FilterIcon from "../../assets/images/icons/Bold-Filter.svg";
import ExpediaDark from "../../assets/images/icons/expedia-logo-dark.svg";
import Expedia from "../../assets/images/icons/expedia.svg";
import GeniusImage from "../../assets/images/genius-bird.png";
import Footer from "../../components/footer";
import "./styles.scss";
import {
    getAppConfig,
    getHotels,
    resetChatGPTOffers,
    setActivityIndicator,
    setPagination,
    setResponseType,
    setShowRectangular,
    setStatusCodeByGuid,
} from "../../redux/slices/appconfigSlice";
import { useDispatch, useSelector } from "react-redux";
import {
    getSearchFilters,
    setAppFilters,
    setDepartureFrom,
    setFlightCabinClass,
    setNumberOfStops,
    setPriceRangeValue,
    setTravelDate,
    setTravelTime,
} from "../../redux/slices/searchFilterSlice";
import AppConfig from "../../helpers/config";
import {
    getSearchOnlyListingParams,
    getTravelersData,
} from "../../helpers/common";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DesireCountryModal from "../../components/Modals/DesireCountryModal";
import DepartureFromModal from "../../components/Modals/DepartureFromModal";
import moment from "moment";
import { getLoginConfig } from "../../redux/slices/loginconfigSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faTimes } from "@fortawesome/pro-light-svg-icons";
import { faMapMarkerAlt, faUser } from "@fortawesome/pro-solid-svg-icons";
import GridIcon from "../../assets/images/icons/grid-icon.svg";
import RangeBar from "../../components/slider/RangeBar";
import ScrollLock from "../../components/ScrollLock";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import { resetChatsInStore } from "../../redux/slices/chatBotSlice";
import MapJson from "../../assets/images/lottieViews/map.json";
import BulbJson from "../../assets/images/lottieViews/bulb.json";
import GeniusJson from "../../assets/images/lottieViews/genius.json";
import Lottie from "lottie-react";
import Travelers from "../../components/sections/QuickFilters/Travelers";
import CalenderDateRangePicker from "../../components/CalenderDatePicker/CalenderDateRangePicker";
import Swal from "sweetalert2";

const Search = () => {
    const url = window.location.href;
    const objUrl = new URL(url);
    const resultRef = React.useRef();
    const calendarTriggerRef = useRef();
    const { T } = useTranslationCustom();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const searchTypeRef = useRef("Free");
    const searchParams = new URLSearchParams(objUrl.search);
    const { guid: urlGUID } = useParams();
    const appconfig = useSelector(getAppConfig);
    const loginConfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);
    const [showFilters, setShowFilters] = useState(false);
    const [justArrived, setJustArrived] = useState(true);
    const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showTraveler, setShowTraveler] = useState(false);
    const isPriceResetRef = useRef(false);
    const [modals, setModals] = useState({
        destination: false,
        departure: false,
    });


    //   const [dateShouldReset, setDateShouldReset] = useState(false);
    const toggleFilter = () => setShowFilters(true);
    const hideFilter = () => setShowFilters(false);
    // let HomePackageGUID = '';

    // Confirms the selected package's GUID is in the URL.
    // const isPackageGuid = () => !!appconfig?.packageTypes.find(f => f.guid === urlGUID);

    const handleSearchTypeRef = (type) => {
        searchTypeRef.current = type;
    }

    // Helper function for cross-browser smooth scroll (iOS Safari compatible)
    const scrollToElement = (element) => {
        if (!element) return;

        // Detect iOS Safari
        const isIosSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) &&
            !window.MSStream;

        element.scrollIntoView({
            behavior: isIosSafari ? "auto" : "smooth",
            block: "start",
        });
    };

    useEffect(() => {
        getPackagesInitially(); // Fetches packages.
    }, []);

    // Sync page state with URL params
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlPage = Number(params.get("page")) || 1;
        if (urlPage !== page) {
            setPage(urlPage);
        }
    }, [location.search]);

    // Update pagination and data
    useEffect(() => {
        if (!justArrived && appconfig.responseType !== "RealTime") {
            const params = getSearchOnlyListingParams({
                guid: urlGUID,
                page: page,
                searchfilters,
                loginconfig: loginConfig,
                initialSearch: false,
                bigSearch: true,
                SearchType: searchTypeRef.current,
            });

            dispatch(getHotels({ params, T, dispatch, handleSearchTypeRef }));
        } else {
            setJustArrived(false);
            // HomePackageGUID = ''
        }
    }, [location.pathname, location.search]);

    useEffect(() => {
        if (!justArrived && !isPriceResetRef.current) {
            const params = new URLSearchParams(location.search);
            const urlPage = Number(params.get("page"));

            if (urlPage && urlPage === 1) {
                const params = getSearchOnlyListingParams({
                    guid: urlGUID,
                    page: 1,
                    searchfilters,
                    loginconfig: loginConfig,
                    initialSearch: true,
                    SearchType: searchTypeRef.current,
                });

                dispatch(getHotels({ params, T, dispatch, handleSearchTypeRef }));
                return;
            }

            navigate(
                "/search/" +
                appconfig.correlationId +
                "/query?page=1&locale=" +
                loginConfig.locale.code +
                "&currency=" +
                loginConfig?.currency?.code
                , { replace: true }
            );
        }
        if (isPriceResetRef.current) {
            isPriceResetRef.current = false;
        }
    }, [searchfilters.defaultPrice]);

    const getPackagesInitially = () => {
        try {
            // "Listing" is passed when arriving from the Chat "Explore All Offers" flow (see handleNavigationToMoreOffers).
            searchTypeRef.current = searchParams.get("searchType") === "Listing" ? "Listing" : "GPT";
            const params = getSearchOnlyListingParams({
                guid: urlGUID,
                page: page,
                searchfilters,
                loginconfig: loginConfig,
                initialSearch: false,
                SearchType: searchTypeRef.current,
            });
            dispatch(getHotels({ params, T, dispatch, handleSearchTypeRef }));
        } catch (error) {
            console.error(error);
            dispatch(setActivityIndicator(false));
            navigate("/", { replace: true });
        }
    };

    // Get other packages for response type RealTime
    useEffect(() => {
        const handleRealTimeResponse = async () => {
            if (appconfig.responseType === "RealTime") {
                if (appconfig.correlationId === appconfig.statusCodeByGuid?.guid && appconfig.statusCodeByGuid?.warnings?.[0]?.code === '204.02') {
                    const result = await Swal.fire({
                        title: T("Common:No_Matches_Under_Budget"),
                        text: appconfig.statusCodeByGuid?.warnings?.[0]?.description || T("Common:No_Matches_Under_Budget_Description"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                        iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                        showCancelButton: true,
                        confirmButtonText: T("Buttons:Button_Yes"),
                        cancelButtonText: T("Buttons:Button_No"),
                        confirmButtonColor: "#05CE78",
                        cancelButtonColor: "#596C7F",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    // IF USER CLICKS YES → retry with full app price range
                    if (result.isConfirmed) {
                        isPriceResetRef.current = true;
                        searchTypeRef.current = "Popup";
                        dispatch(setPriceRangeValue({ low: AppConfig.minPrice, high: AppConfig.maxPrice }));
                        dispatch(setStatusCodeByGuid({}));
                    }
                }

                if (appconfig.correlationId === appconfig.statusCodeByGuid?.guid && appconfig.statusCodeByGuid?.warnings?.[0]?.code === '204.03') {
                    await Swal.fire({
                        title: T("Common:Offers_Not_Found"),
                        text: appconfig.statusCodeByGuid?.warnings?.[0]?.description,
                        iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                        showCancelButton: false,
                        confirmButtonText: T("Buttons:Button_Ok"),
                        confirmButtonColor: "#05CE78",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }

                setTimeout(() => {
                    dispatch(setResponseType(null));
                    navigate(
                        "/search/" +
                        appconfig.correlationId +
                        "/query?page=1&locale=" +
                        loginConfig.locale.code +
                        "&currency=" +
                        loginConfig?.currency?.code
                        , { replace: true }
                    );
                }, 1000);
            }
        };

        handleRealTimeResponse();
    }, [appconfig.responseType]);

    useEffect(() => {
        if (!justArrived) {
            dispatch(resetChatsInStore());
            dispatch(resetChatGPTOffers());

            setTimeout(() => {
                navigate("/");
            }, 100);
        }
    }, [loginConfig.currency, loginConfig.locale]);

    const handleCheckBox = (e, item, multiple) => {
        let _filters = [...searchfilters.appFilters] || [];
        if (e?.target?.checked || e === true) {
            if (item.key) {
                const index = _filters.findIndex((f) => f.key === item.key);
                if (index !== -1 && !multiple) {
                    _filters[index] = {
                        _id: `checkbox-${item.id}-${item.text}-${item?.key}`,
                        ...item,
                    };
                } else {
                    _filters.push({
                        _id: `checkbox-${item.id}-${item.text}-${item?.key}`,
                        ...item,
                    });
                }
            } else {
                _filters.push({
                    _id: `checkbox-${item.id}-${item.text}-${item?.key}`,
                    ...item,
                });
            }

            dispatch(setAppFilters(_filters));
        } else {
            handleDeleteFilter(`checkbox-${item.id}-${item.text}-${item?.key}`);
        }
        if (item?.key === "departure_date" && e?.target?.checked === true) {
            dispatch(
                setTravelDate({
                    startDate: new Date(
                        moment(searchfilters.travelDate.startDate).subtract("days", item.id)
                    ),
                    endDate: new Date(
                        moment(searchfilters.travelDate.endDate).add("days", item.id)
                    ),
                })
            );
        } else if (item?.key === "departure_date" && e?.target?.checked === false) {
            dispatch(
                setTravelDate({
                    startDate: new Date(
                        moment(searchfilters.travelDate.startDate).add("days", item.id)
                    ),
                    endDate: new Date(
                        moment(searchfilters.travelDate.endDate).subtract("days", item.id)
                    ),
                })
            );
        }
    };

    const handleDeleteFilter = (id) => {
        let _filters = [...searchfilters.appFilters];
        dispatch(setAppFilters(_filters?.filter((f) => f._id !== id)));
    };

    const handleSearchFromScratch = (e) => {
        e.preventDefault();

        scrollToElement(resultRef?.current);

        if (!searchfilters.selectedDesireCountry) {
            return toast.info(T("Toasts:Please_Choose_Package_Destination"));
        }

        if (!searchfilters?.departureFrom?.length) {
            return toast.info(T("Toasts:Please_Choose_Departure"));
        }

        if (
            !searchfilters.travelDate.startDate ||
            !searchfilters.travelDate.endDate
        ) {
            return toast.info(T("Toasts:Please_Select_Date_Range"));
        }

        dispatch(setPagination(null));
        setPage(1);

        searchTypeRef.current = "Filter";

        const params = getSearchOnlyListingParams({
            guid: "",
            page: 1,
            searchfilters,
            loginconfig: loginConfig,
            bigSearch: true,
            SearchType: searchTypeRef.current,
        });

        dispatch(getHotels({ params, T, dispatch, shouldAddToSearchHistory: true, handleSearchTypeRef }));
        hideFilter();
    };

    const SortBySection = () => {
        return (
            <>
                <div className="list-grid-toggler">
                    <a
                        onClick={() =>
                            dispatch(setShowRectangular(!appconfig.showRectangular))
                        }
                    >
                        <img
                            src={appconfig.showRectangular ? GridIcon : ListIcon}
                            alt={"list-icon"}
                        />
                    </a>
                </div>
            </>
        );
    };

    const handlePriceChange = async ({ low, high }) => {
        // navigate(
        //     "/search/" +
        //     appconfig.correlationId +
        //     "/query?page=1&locale=" +
        //     loginConfig.locale.code +
        //     "&currency=" +
        //     loginConfig?.currency?.code
        //     , { replace: true }
        // )

        // await new Promise(resolve => setTimeout(resolve, 100)); // Wait for URL to update
        setPage(1);
        dispatch(setPriceRangeValue({ low, high }));
    };


    return (
        <>
            <div className="main-wrapper search-page">
                <AppHeader />
                <main className="body-wrapper">
                    {/*Quick filters section*/}
                    <div id="quickSearch" className="quick-search-wrapper">
                        <div className="container">
                            <div className="chips-row w-100 d-flex justify-content-center">
                                {location.pathname.includes("/search/") && (
                                    <div className="my-3 quick-filter-back">
                                        <a
                                            className="animated-back-btn"
                                            onClick={() => navigate('/', { replace: true })}
                                        >
                                            <Lottie
                                                animationData={GeniusJson}
                                                loop={true}
                                                className="genius-animation"
                                            />
                                            <Lottie
                                                animationData={BulbJson}
                                                loop={true}
                                                className="bulb-animation"
                                            />
                                            <span>{T("Buttons:Button_Chat_Ai")}</span>
                                        </a>
                                    </div>
                                )}
                                <a
                                    rel="noopener noreferrer"
                                    className="show-map-link"
                                    onClick={() =>
                                        navigate(`/map/${appconfig?.correlationId}/offers/search/${page}`)
                                    }
                                >
                                    <Lottie
                                        animationData={MapJson}
                                        loop={true}
                                        className="map_animation"
                                    />
                                    {/* <span>{T("Buttons:View_On_Map")}</span> */}
                                    <span>{T("Packages_Detail:Show_On_Map")}</span>
                                </a>
                                <ul className="search-tags hide-on-small-screen">
                                    {searchfilters?.appFilters?.map((filter, index) => {
                                        return (
                                            <li key={index}>
                                                {filter?.text}
                                                <a onClick={() => handleDeleteFilter(filter?._id)}>
                                                    <FontAwesomeIcon
                                                        icon={faTimes}
                                                        className="close-icon"
                                                    />
                                                </a>
                                            </li>
                                        );
                                    })}
                                    {searchfilters.appFilters?.length ? (
                                        <li className="reset-all">
                                            <a onClick={() => dispatch(setAppFilters([]))}>
                                                {T("Buttons:Reset_All")}
                                                <FontAwesomeIcon
                                                    icon={faTimes}
                                                    className="close-icon"
                                                />
                                            </a>
                                        </li>
                                    ) : (
                                        ""
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/*End Quick filters section*/}

                    <div id="result" ref={resultRef} className="search-result-wrapper">
                        <div className="container">
                            {/*offers count section*/}
                            <div className="row for-small-screen">
                                <div className="col-12">
                                    <div className="filter-holder">
                                        <div className="hide-on-small-screen d-flex items-center">
                                            <a
                                                rel="noopener noreferrer"
                                                className="show-map-link"
                                                onClick={() =>
                                                    navigate(
                                                        `/map/${appconfig?.correlationId}/offers/search/${page}`
                                                    )
                                                }
                                            >
                                                <Lottie
                                                    animationData={MapJson}
                                                    loop={true}
                                                    className="map_animation"
                                                />
                                                <span>{T("Packages_Detail:Show_On_Map")}</span>
                                            </a>
                                            <div className="top-caption flex-grow-1 align-self-center">
                                                <h5 className="">
                                                    {T("Filters:Filters_Packages_Found", {
                                                        count: appconfig?.metaDataCount || 0,
                                                    })}
                                                </h5>
                                            </div>

                                            <div className="filter-action">
                                                <SortBySection />
                                            </div>
                                        </div>
                                        <div className="filter-mob-wrapper show-on-small-screen">
                                            <div className="filter-toggles ">
                                                <a onClick={toggleFilter}>
                                                    {" "}
                                                    <img src={FilterIcon} alt={"filter-icon"} />{" "}
                                                    {T("Filters:Filters_Text")}
                                                </a>
                                                <span className="count">
                                                    {searchfilters.appFilters.length}
                                                </span>
                                            </div>

                                            <div className="flip-animation">
                                                <div className={`flipper auto-flip`}>
                                                    <p className="powered-by-text mt-0">
                                                        {T("Filters:Footer_Powered_By")}{" "}
                                                        <img
                                                            src={loginConfig.darkMode ? Expedia : ExpediaDark}
                                                            alt={"expedia"}
                                                        />
                                                    </p>
                                                    <div className="top-caption flex-grow-1 align-self-center">
                                                        <h5 className="">
                                                            {T("Filters:Filters_Packages_Found", {
                                                                count: appconfig?.metaDataCount || 0,
                                                            })}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <SortBySection />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*end section*/}

                            <div className="row">
                                <ScrollLock isOpen={true}>
                                    <div className="col-xl-3 col-lg-4 sidebar-filters">
                                        <form
                                            className={
                                                showFilters
                                                    ? "collapsable-filter-wrapper open-filter"
                                                    : "collapsable-filter-wrapper"
                                            }
                                        >
                                            {/*selected filters by side left view*/}
                                            <div className="filter-header show-on-small-screen">
                                                <div className="filter-title-area">
                                                    <a onClick={hideFilter} className="close-icon">
                                                        <FontAwesomeIcon icon={faTimes} />
                                                    </a>
                                                    <h6>
                                                        {" "}
                                                        {T("Filters:Filters_Text")}{" "}
                                                        <span className="count">
                                                            {searchfilters.appFilters.length}
                                                        </span>{" "}
                                                    </h6>
                                                    <a
                                                        onClick={() => dispatch(setAppFilters([]))}
                                                        className="delete-all-link"
                                                    >
                                                        {T("Buttons:Delete_All")}{" "}
                                                    </a>
                                                </div>
                                                <ul className="search-tags">
                                                    {searchfilters.appFilters?.map((filter, index) => {
                                                        return (
                                                            <li key={index}>
                                                                {filter.text}
                                                                <a
                                                                    onClick={() => handleDeleteFilter(filter._id)}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={faTimes}
                                                                        className="close-icon"
                                                                    />
                                                                </a>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                            {/*End of section*/}

                                            <div className="collapsable-block">
                                                <div className="rangeslider">
                                                    <RangeBar
                                                        lowPrice={searchfilters.defaultPrice.low}
                                                        highPrice={searchfilters.defaultPrice.high}
                                                        onChangePriceHandler={handlePriceChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="collapsable-block">
                                                <h6 className="heading fs-14 medium">
                                                    {T("Filters:Check_In")} - {T("Filters:Check_Out")}
                                                </h6>

                                                <div className="form-group">
                                                    <FontAwesomeIcon
                                                        icon={faCalendar}
                                                        className="floating-icon"
                                                    />
                                                    <input
                                                        ref={calendarTriggerRef}
                                                        readOnly
                                                        type="text"
                                                        style={{ paddingLeft: "33px" }}
                                                        value={
                                                            `${searchfilters.travelDate.startDate
                                                                ? moment(searchfilters.travelDate.startDate).format("MMM DD")
                                                                : T("Filters:Info_No_Date_Selected")
                                                            } - ${searchfilters.travelDate.endDate
                                                                ? moment(searchfilters.travelDate.endDate).format("MMM DD")
                                                                : T("Filters:Info_No_Date_Selected")
                                                            }`
                                                        }
                                                        onClick={() => {
                                                            setShowCalendar(!showCalendar);
                                                            setShowTraveler(false);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <CalenderDateRangePicker
                                                show={showCalendar}
                                                triggerRef={calendarTriggerRef}
                                                onSelect={() => setShowCalendar(false)}
                                                onClose={() => setShowCalendar(false)}
                                            />

                                            <div className="collapsable-block">
                                                <h6 className="heading fs-14 medium">
                                                    {T("Filters:Destinations")}
                                                </h6>

                                                <div className="form-group">
                                                    <FontAwesomeIcon
                                                        icon={faMapMarkerAlt}
                                                        className="floating-icon"
                                                    />
                                                    <input
                                                        readOnly
                                                        type="text"
                                                        name="desireLocation"
                                                        value={
                                                            searchfilters?.selectedDesireCountry?.keyword ||
                                                            T("Filters:Choose_Destination")
                                                        }
                                                        onClick={() =>
                                                            setModals({
                                                                ...modals,
                                                                destination: !modals.destination,
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="collapsable-block">
                                                <h6 className="heading fs-14 medium">
                                                    {T("Filters:Departure_From")}
                                                </h6>
                                                <div className="form-group">
                                                    <FontAwesomeIcon
                                                        icon={faMapMarkerAlt}
                                                        className="floating-icon"
                                                    />
                                                    <input
                                                        readOnly
                                                        type="text"
                                                        name="desireLocation"
                                                        value={T("Filters:Filter_Departure_Placeholder")}
                                                        onClick={() =>
                                                            setModals({
                                                                ...modals,
                                                                departure: !modals.departure,
                                                            })
                                                        }
                                                    />
                                                </div>
                                                <ul className="loaction-tag">
                                                    {searchfilters.departureFrom?.map(
                                                        (_departure, index) => {
                                                            return (
                                                                <li
                                                                    key={index}
                                                                    onClick={() =>
                                                                        dispatch(
                                                                            setDepartureFrom(
                                                                                searchfilters.departureFrom?.filter(
                                                                                    (f) => f.code !== _departure.code
                                                                                )
                                                                            )
                                                                        )
                                                                    }
                                                                >
                                                                    {`${_departure?.code} ${_departure?.name}`}{" "}
                                                                    <span>x</span>
                                                                </li>
                                                            );
                                                        }
                                                    )}
                                                </ul>
                                            </div>

                                            <div className="collapsable-block">
                                                <h6 className="heading fs-14 medium">
                                                    {T("Common:Travelers")}
                                                </h6>
                                                <div className="form-group traveler">
                                                    <Dropdown
                                                        show={showTraveler}
                                                        onToggle={(show) => {
                                                            setShowTraveler(show);
                                                            setShowCalendar(false);
                                                        }}
                                                        align={
                                                            { sm: "start" } | { md: "end" } | { lg: "end" }
                                                        }
                                                    >
                                                        <Dropdown.Toggle>
                                                            <div className="traveler-section">
                                                                <div className="icon">
                                                                    <FontAwesomeIcon icon={faUser} />
                                                                </div>
                                                                <div className="text ">
                                                                    <p className="white-text no-margin">{`${searchfilters.travelers?.length || 0
                                                                        } ${searchfilters.travelers?.length > 1 ? T("Common:Rooms") : T("Common:Room")}, ${getTravelersData(searchfilters).total} ${getTravelersData(searchfilters).total <= 1
                                                                            ? T("Common:Traveler").toLowerCase()
                                                                            : T("Common:Travelers").toLowerCase()
                                                                        }`}</p>
                                                                </div>
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Travelers setShowTraveler={setShowTraveler} />
                                                    </Dropdown>
                                                </div>
                                            </div>

                                            <div className="collapsable-block">
                                                <Collapsible
                                                    title={T("Filters:Filters_Hotel_Rating")}
                                                    _activeKey={"rating"}
                                                    items={AppConfig.guestRating}
                                                    handleClickEvent={handleCheckBox}
                                                />
                                            </div>

                                            <div className="collapsable-block">
                                                <Collapsible
                                                    title={T("Filters:Filters_Stops")}
                                                    _activeKey={"stops"}
                                                    handleClickEvent={(e, item) => {
                                                        dispatch(setNumberOfStops(item?.id));
                                                        handleCheckBox(e, item);
                                                    }}
                                                    items={AppConfig.steps}
                                                />
                                            </div>
                                            <div className="collapsable-block">
                                                <Collapsible
                                                    title={T("Filters:Filters_Flight_Departure_Times")}
                                                    _activeKey={"departure-time"}
                                                    handleClickEvent={(e, item) => {
                                                        dispatch(
                                                            setTravelTime({
                                                                departureTime: e?.target?.checked
                                                                    ? item?.StartTime && item?.EndTime
                                                                        ? `${item.StartTime}-${item.EndTime}`
                                                                        : "Anytime"
                                                                    : null,
                                                                arrivalTime:
                                                                    searchfilters?.travelTime?.arrivalTime ||
                                                                    null,
                                                            })
                                                        );
                                                        handleCheckBox(e, item);
                                                    }}
                                                    items={AppConfig.departureTime}
                                                />
                                            </div>
                                            <div className="collapsable-block">
                                                <Collapsible
                                                    title={T("Filters:Filters_Flight_Return_Times")}
                                                    _activeKey={"arrival-time"}
                                                    handleClickEvent={(e, item) => {
                                                        dispatch(
                                                            setTravelTime({
                                                                departureTime:
                                                                    searchfilters?.travelTime?.departureTime ||
                                                                    null,
                                                                arrivalTime: e?.target?.checked
                                                                    ? item?.StartTime && item?.EndTime
                                                                        ? `${item.StartTime}-${item.EndTime}`
                                                                        : "Anytime"
                                                                    : null,
                                                            })
                                                        );
                                                        handleCheckBox(e, item);
                                                    }}
                                                    items={AppConfig.arrivalTime}
                                                />
                                            </div>

                                            <div className="collapsable-block">
                                                <h6 className="heading fs-14 medium">
                                                    {T("Filters:Filters_Class")}
                                                </h6>
                                                <div className="form-group dropdown-with-checkbox">
                                                    <Dropdown>
                                                        <Dropdown.Toggle>
                                                            {searchfilters.appFilters?.find(
                                                                (f) => f?.key === "airline_class"
                                                            )?.text || T("Filters:Filers_Choose_Class")}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {AppConfig.airlineClasses.map(
                                                                (airline, index) => {
                                                                    return (
                                                                        <Dropdown.Item
                                                                            key={index}
                                                                            onClick={() => {
                                                                                handleCheckBox(true, airline);
                                                                                dispatch(
                                                                                    setFlightCabinClass(airline.value)
                                                                                );
                                                                            }}
                                                                            active={
                                                                                searchfilters.appFilters.find(
                                                                                    (f) => f?.key === "airline_class"
                                                                                )?.id === airline?.id
                                                                            }
                                                                        >
                                                                            {airline?.text}
                                                                        </Dropdown.Item>
                                                                    );
                                                                }
                                                            )}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                            <div className="filters-sidebar-btn">
                                                <a
                                                    className="apply-filter-btn"
                                                    onClick={handleSearchFromScratch}
                                                >
                                                    {T("Buttons:Search")}
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </ScrollLock>

                                <div className="col-xl-9 col-lg-8">
                                    <div className="hotal-item-wrapper grid">
                                        {appconfig.showRectangular ? <ListView /> : <GridView />}
                                    </div>

                                    <div className="custom-pagination">
                                        <Pagination
                                            _setPage={(page) => {
                                                searchTypeRef.current = "Pagination";
                                                let url = window.location.pathname;
                                                navigate(
                                                    url +
                                                    "?page=" +
                                                    page +
                                                    "&locale=" +
                                                    loginConfig.locale.code +
                                                    "&currency=" +
                                                    loginConfig?.currency?.code
                                                    , { replace: true }
                                                );
                                                setPage(page);
                                                scrollToElement(resultRef?.current);
                                            }}
                                            page={page}
                                        />
                                    </div>

                                    {/*<TextSection/>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
            <DesireCountryModal
                show={modals.destination}
                onHide={() => setModals({ ...modals, destination: false })}
            />
            <DepartureFromModal
                show={modals.departure}
                onHide={() => setModals({ ...modals, departure: false })}
                onApplyButtonHandler={(values) => dispatch(setDepartureFrom(values))}
            />
        </>
    );
};

export default Search;
